import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';

//vuex
import store from './store';

import "material-design-icons-iconfont/dist/material-design-icons.css";

//routes
import { routes } from './routes/router';

// import plugin
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";

import VueJwtDecode from 'vue-jwt-decode'
import VOtpInput from "vue-otp-input";
import Toasted from 'vue-toasted'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common["Content-Type"] = 'application/json';
axios.defaults.headers.common["Access-Control-Allow-Methods"] = "POST, GET, PUT, DELETE";

if (localStorage.getItem("frinkUserToken") != null) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("frinkUserToken");
}

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          const response = await axios.post('/api/panel/auth/refresh-token', { refreshToken: refreshToken });
          localStorage.setItem("frinkUserToken", response.data.payload.accessToken);
          localStorage.setItem("refreshToken", response.data.payload.refreshToken);
          axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.token;
          processQueue(null, response.data.token);
          window.location.reload();
          return axios(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          localStorage.removeItem("frinkUserToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/";
        } finally {
          isRefreshing = false;
        }
      } else {
        localStorage.removeItem("frinkUserToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
      }
    }
    if(error.response && error.response.status == 403){
      localStorage.removeItem("frinkUserToken");
      localStorage.removeItem("nameSurname");
      localStorage.removeItem("userRoles");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueJwtDecode);
Vue.use(VueTheMask);
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "md"
});
Vue.use(Toasted);
Vue.component("v-otp-input", VOtpInput);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.required) {
    if (localStorage.getItem("frinkUserToken") != null) {
      if (to.meta.roles === undefined) {
        next();
      } else {
        let userRolesString = localStorage.getItem('userRoles');
        let roles = userRolesString && userRolesString !== 'undefined'
          ? JSON.parse(userRolesString)
          : [];
        let isAuth = to.meta.roles.some(role => roles.includes(role));
        if (isAuth) {
          next();
        } else {
          if (to.path !== "/dashboard") {
            next("/dashboard");
          } else {
            next();
          }
        }
      }
    } else {
      if (to.path !== "/") {
        next("/");
      } else {
        next();
      }
    }
  } else {
    if (localStorage.getItem("frinkUserToken") != null) {
      if (to.path !== "/dashboard") {
        next("/dashboard");
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

new Vue({
  store,
  vuetify,
  render: h => h(App),
  router
}).$mount('#app')
